exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* START EVOQ COLOR PALETTE */\n/* END EVOQ COLOR PALETTE */\n/* START ATTENTION COLORS */\n/* END ATTENTION COLORS */\n/* SVG HOVER STATES */\nsvg {\n  fill: #C8C8C8;\n}\nsvg:hover {\n  fill: #6F7273;\n}\nsvg:active {\n  fill: #1E88C3;\n}\n/* END SVG HOVER STATES */\n._3AB740VT1v1WPjY6HyKV8E > .package-information-header > h6 {\n  margin-bottom: 10px;\n  text-transform: uppercase;\n}\n._3AB740VT1v1WPjY6HyKV8E > .package-information-header > p {\n  margin-bottom: 25px;\n}\n", ""]);

// Exports
exports.locals = {
	"pkgInformationBox": "_3AB740VT1v1WPjY6HyKV8E"
};